import ConfirmarExclusao from '@/global/guides/Dialog/ConfirmarExclusao'
import { useNavigate, useParams } from 'react-router-dom'
import { faltasCadastradas } from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import { useStore } from 'store'
import { useDigitacaoContext } from '../pages/useDigitacaoContext'
import { useUpdateDigitacaoQueryData } from '../pages/useDigitacaoData'

interface IProps {
    open: boolean
    onClose: () => void
}

export default function ExcluirFaltaCadastrada({ open, onClose }: IProps) {
    const { setQueryData } = useUpdateDigitacaoQueryData()
    const navigate = useNavigate()
    const { data } = useDigitacaoContext()
    const { id } = useParams()
    const empresaId = useStore(state => state.companyId)

    const falta = data.find(
        ({ faltaCadastrada }) => faltaCadastrada?.id === Number(id),
    )?.faltaCadastrada

    const { mutateAsync, isLoading } =
        faltasCadastradas.mutations.useSoftDelete({
            invalidateQuery: true,
            onSuccess: async () => {
                setQueryData(
                    'FALTA_CADASTRADA',
                    {
                        ...falta!,
                        deletedAt: new Date(),
                    },
                    true,
                )
                toast.success('Falta excluída com sucesso')
                navigate(-1)
            },
            onError: e => {
                toast.error(e.message)
            },
        })

    if (!falta) return null

    return (
        <ConfirmarExclusao
            width="2xl"
            permissao={['delete', 'FaltasJustificadasOuInjustificadas']}
            open={open}
            onClose={onClose}
            loading={isLoading}
            exigirMotivo
            onConfirm={({ motivo }) =>
                mutateAsync({ id, motivo, empresaId } as any)
            }
            title="Tem certeza que deseja excluir a falta?"
        />
    )
}
